module.exports = __webpack_public_path__ + "img/small_businesses_top_banner.5055d39f.webp";